function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "I2");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-V2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "PROJECT",
  transform: "translate(-1634.000000, -272.000000)"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(1617.000000, 262.000000)"
}, React.createElement("g", {
  id: "Group-4"
}, React.createElement("g", {
  id: "I2",
  transform: "translate(17.000000, 10.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group-5"
}, React.createElement("path", {
  d: "M9.33834783,19.1751652 C9.16408696,18.8376 8.6793913,18.7645565 8.25469565,19.0134261 L6.01591304,20.3261217 C5.80565217,20.4492522 5.58652174,20.3292522 5.64234783,20.1210783 L8.41173913,9.84333913 C8.71121739,8.7309913 8.07417391,7.74751304 6.906,7.70786087 C6.40773913,7.69116522 5.90530435,7.84351304 5.46234783,8.10177391 C5.45973913,8.10281739 5.45765217,8.10386087 5.45556522,8.10542609 L0.55226087,10.9802087 C0.172956522,11.2029913 -0.0717391304,11.615687 0.0190434783,11.9501217 C0.0936521739,12.2250783 0.338347826,12.3727304 0.627913043,12.3737739 C0.794347826,12.3742957 0.975913043,12.3262957 1.14704348,12.2256 L3.39886957,10.9045565 C3.60965217,10.7814261 3.82826087,10.9019478 3.77243478,11.1096 L1.00147826,21.3967304 C0.730173913,22.4026435 1.22008696,23.3188174 2.22704348,23.4862957 C2.7993913,23.5807304 3.39417391,23.4382957 3.91226087,23.147687 C3.92321739,23.1419478 3.93521739,23.1398609 3.94565217,23.1336 L8.88495652,20.2379478 C9.3086087,19.9896 9.51208696,19.5132522 9.33834783,19.1751652",
  id: "Fill-1"
}), React.createElement("path", {
  d: "M4.73342609,2.5982087 C4.95255652,1.06481739 6.23603478,0.000469565217 7.83203478,0.000469565217 C9.6482087,0.000469565217 10.8372522,1.34655652 10.5873391,3.16168696 C10.3363826,4.72690435 9.08473043,5.82307826 7.51951304,5.82307826 C5.67255652,5.82307826 4.4829913,4.44516522 4.73342609,2.5982087",
  id: "Fill-3"
})))))));

var SvgIconInformation = function SvgIconInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "11px",
    height: "24px",
    viewBox: "0 0 11 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconInformation.35a1d3a1.svg";
export { ForwardRef as ReactComponent };